var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHideEyes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4413 1.708L16.7054 0.972054C16.4974 0.764063 16.1134 0.796072 15.8734 1.08402L13.3132 3.62798C12.1611 3.13204 10.8972 2.89204 9.56918 2.89204C5.61706 2.90798 2.19328 5.21195 0.545165 8.52415C0.449138 8.73215 0.449138 8.98808 0.545165 9.16406C1.3131 10.7321 2.46517 12.0281 3.90517 13.0041L1.80918 15.132C1.56918 15.372 1.53717 15.756 1.69722 15.964L2.43316 16.7C2.64115 16.908 3.02514 16.8759 3.26514 16.588L17.313 2.54011C17.6171 2.30024 17.6491 1.91628 17.4411 1.70827L17.4413 1.708ZM10.4172 6.53988C10.1452 6.47586 9.85722 6.39591 9.58519 6.39591C8.22514 6.39591 7.13726 7.48393 7.13726 8.84384C7.13726 9.11585 7.20128 9.4038 7.28123 9.67582L6.20911 10.7319C5.88916 10.1719 5.71317 9.5478 5.71317 8.84388C5.71317 6.7159 7.4252 5.00388 9.55318 5.00388C10.2572 5.00388 10.8812 5.17986 11.4412 5.49982L10.4172 6.53988Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5933 8.52409C18.0333 7.40404 17.2972 6.39611 16.3853 5.58008L13.4093 8.52409V8.84404C13.4093 10.972 11.6972 12.684 9.56927 12.684H9.24931L7.36133 14.572C8.06539 14.716 8.80133 14.812 9.52133 14.812C13.4735 14.812 16.8972 12.5081 18.5454 9.17991C18.6893 8.95584 18.6893 8.73193 18.5933 8.52392L18.5933 8.52409Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHideEyes);
export default __webpack_public_path__ + "static/media/ic_hide_eyes.094df67ec1fd2d71f50ccb00fa1fcec4.svg";
export { ForwardRef as ReactComponent };